import React, { useContext, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';

import './styles.scss';
import { getCompetitionGamesById, getGameDetails } from '@racings/api/requests';
import { GetArrayGame } from '@common/helpers/util/swarmTreeDestructuring';
import { RacingsContext } from '@racings/store/context';
import { Swarm } from '@lbs/swarm-client';
import { TimeFilter } from './components/timeFilter';
import { RacingGame } from './components/racingGame';
import { DetailsHeader } from './components/detailsHeader';

const RacingDetails = ({ routePrefix = '' }) => {
  const [{ dateFilter }] = useContext(RacingsContext);
  const { gameId: activeGameId, compId, regionAlias } = useParams();
  const [searchParams] = useSearchParams();
  const dateFilterForSearch = searchParams.get('dateFilter') || dateFilter;

  const [competitionGames, setCompetitionGames] = useState([]);
  const [gameList, setGameList] = useState([]);
  useEffect(() => {
    let subId;
    const swarmInstance = Swarm.getInstance();

    (async () => {
      const { data, subid } = await swarmInstance.subscribe(
        getCompetitionGamesById(
          +compId,
          moment.unix(dateFilterForSearch).startOf('day').unix(),
        ),
        (data) => {
          setCompetitionGames(GetArrayGame(data?.game, 'start_ts'));
        },
        true,
      );

      setCompetitionGames(GetArrayGame(data?.game, 'start_ts'));

      subId = subid;
    })();

    return () => swarmInstance.unsubscribe(subId);
  }, [compId, dateFilterForSearch]);

  useEffect(() => {
    let subId;
    const swarmInstance = Swarm.getInstance();

    (async () => {
      const { data, subid } = await swarmInstance.subscribe(
        getGameDetails(+activeGameId, +compId, regionAlias),
        (data) => {
          setGameList(GetArrayGame(data?.game));
        },
        true,
      );
      setGameList(GetArrayGame(data?.game));

      subId = subid;
    })();

    return () => swarmInstance.unsubscribe(subId);
  }, [activeGameId, compId, regionAlias]);

  const competitionName = competitionGames[0]?.competitionName || '';

  return (
    <div className="racing-details-container">
      <DetailsHeader
        routePrefix={routePrefix}
        gameList={gameList}
        competitionName={competitionName}
        activeGameId={activeGameId}
      />
      <div className="time-filter-wrapper">
        {competitionGames
          && !!competitionGames.length
          && <TimeFilter routePrefix={routePrefix} competitionGames={competitionGames} />}
      </div>
      <div className="games-list">
        {gameList?.filter((game) => (game.start_ts >= moment().unix())).map((game) => (
          <RacingGame
            key={game.id}
            game={game}
            activeGameId={activeGameId}
            competitionName={competitionName}
          />
        ))}
      </div>
    </div>

  );
};

export default RacingDetails;
